import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { Modal, Button } from 'react-bootstrap';
import { insertTableBd, updateTableBd } from '../../../config/functions';

export const ModalOperEdit = (
    {
        operadoraAll,
        setIsLoading,
        show,
        handleClose,
        setOperadoras,
        user,
        getOperadoras,
        tipo
    }
) => {

    const idVar = operadoraAll.id

    const [operadora, setOperadora] = useState('')

    useEffect(() => {
        if (show && operadoraAll) {
            setOperadora(operadoraAll.operadora)
        }
    }, [show])

    const updateOperadora = async () => {
        if (operadora !== '') {
            if (window.confirm('Esta seguro de continuar con la edición?')) {
                setIsLoading(true)
                try {
                    const dataSend = {
                        id: parseInt(idVar),
                        operadora: operadora.toUpperCase(),
                        usuario_modifico: user,
                    }
                    const update = await updateTableBd('updateoperadora', dataSend)
                    toast.success(update);
                    getOperadoras(setOperadoras);
                    handleClose()
                } catch (error) {
                    console.error('Error al realizar la solicitud:', error);
                } finally {
                    setIsLoading(false)
                }
            }
        } else {
            toast.warning('Debe diligenciar Nombre y unidad de medida')
        }
    }

    const saveOperadora = async () => {
        if (operadora !== '') {
            if (window.confirm('Esta seguro de continuar con la creación?')) {
                setIsLoading(true)
                try {
                    const dataSend = {
                        operadora: operadora.toUpperCase(),
                        usuario_modifico: user,
                    }
                    const insert = await insertTableBd('createoperadora', dataSend)
                    toast.success(insert);
                    getOperadoras(setOperadoras);
                    handleClose()
                } catch (error) {
                    console.error('Error al realizar la solicitud:', error);
                } finally {
                    setIsLoading(false)
                }
            }
        } else {
            toast.warning('Debe diligenciar Nombre')
        }
    }

    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {tipo === 'nuevo' ? 'Adicionar' : 'Editar'} Operadora
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row g-3 justify-content-center">
                        <div className="input-group mb-3">
                            <span className="input-group-text" id="basic-addon1">Nombre</span>
                            <input type="text"
                                className="form-control"
                                placeholder="Nombre"
                                aria-label="Nombre"
                                value={operadora}
                                onChange={(e) => setOperadora(e.target.value)} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}> Close </Button>
                    <Button variant="primary"
                        onClick={() => {
                            if (tipo === 'nuevo') saveOperadora()
                            else updateOperadora()
                        }}>
                        {tipo === 'nuevo' ? 'Adicionar' : 'Editar'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
